import { ImageManagerService } from '../managers/image-manager.service';
import { ToroControllerBundle } from './toro-controller-bundle';

export class RDControllerBundle extends ToroControllerBundle
{
    constructor(json: any = null, protected imageManager: ImageManagerService)
    {
        super(json, imageManager);

        this.maxStationRuntimeInHours = 5.9;
        this.Controller.IsControllerSupported = true;       // i.e., Supports Programming
        this.Controller.RunningModeMaxIntervalDays = 9;
        this.showWaterBudgetForProgram = true;  // this.showHideWaterBudgetForProgram;
        this.showMonthlyPercentAdjust = this.showHideMonthlyPercentAdjust;
        this.hasSameValuesForWeekdaysAndIntervalDays = true;

        // TODO: MW: Rain Dial Support -  The following statement must be removed when the api supports RD
        this.Configuration.Programs.forEach(program => program.IsEnabled = true);

        this.showClimateLogicSettings = true;
        this.showClimateLogicType = true;
        this.canUpdateNumberOfStations = this.Controller.IsRecognized === false;
        this.showGetControllerConfiguration = true;
        this.showSensorState = true;
        this.treatUnitsAsTemperature = true;

        this.currentIntervalDayLabel = 'Current Skip Day Interval';

        this.updateDryOutDaysList();
        this.updateFreezeOffTemperatureList();
    }

    public units = [
        { Text: 'Metric', Value: 0 },
        { Text: 'English', Value: 1 },
    ];

    // TODO: check for the values for program-stack overlap when implementing Rain Dial controller
    public programStackOverlapList = [
        { Text: 'Stack', Value: 1 },
        { Text: 'Overlap', Value: 3 }
    ];

    getContrastList()
    {
        const list = [];
        let j = -25;
        for (let i = 6; i <= 26; i += 2)
        {
            list.push({ Text: j.toString() + '%', Value: i });
            j += 5;
        }
        return list;
    }

    updateDryOutDaysList()
    {
        this.dryOutDaysList = [];
        let dryOutValue = 0;
        for (let i = 0; i <= 30; i += 5, dryOutValue += 0.5)
        {
            this.dryOutDaysList.push({ Text: i === 0 ? 'Off' : parseFloat(dryOutValue.toString()).toFixed(1).toString(), Value: i });
        }
    }

    updateFreezeOffTemperatureList()
    {
        this.freezeOffTemperatureList = [];
        for (let i = 29; i <= 45; i += 2)
        {
            this.freezeOffTemperatureList.push({ Text: i.toString(), Value: i });
        }
    }

    // =========================================================================================================================================================
    // Helper Methods
    // =========================================================================================================================================================

    // private get showHideWaterBudgetForProgram(): boolean
    // {
    //     return !(this.Controller.FirmwareVersion === 1.32 || this.Controller.FirmwareVersion === 1.27);
    // }

    private get showHideMonthlyPercentAdjust(): boolean {
        return !(this.Controller.FirmwareVersion === 1.32 || this.Controller.FirmwareVersion === 1.27);
    }
}
